<!-- start of Table box -->
<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs {{sectionclass}}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
	>
		<div class="o-stack__cell">
			<h5>{{ sectiontitle }}</h5>
		</div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
			(click)="downloadDataInCSV($event)"
			target="_blank"
		>
			<i class="fa fa-download" aria-hidden="true"></i>
		</a>
	</div>
	<div class="c-portlet__content">
		<app-accordion-group>
			<app-accordion
				*ngFor="let creative of creatives; let i = index"
				[title]="creative.creativeName"
				[index]="i + 1"
				[active]="i === 0"
				[className]="creative.htmlClass"
			>
				<div *ngIf="!creative.iframeUrl && !isSocial; else socialCreativeBlock">
					<div *ngIf="!creative.isVideoCreative; else videoCreativeBlock">
						<app-marketron-display-creative
							[creative]="creative"
							[creativeIndex]="i"
							(previewCreativeEvent)="previewCreative($event)"
						></app-marketron-display-creative>
					</div>
					<ng-template #videoCreativeBlock>
						<app-marketron-preroll-creative [creative]="creative" [youtubeviewspermission]="youtubeViewsPermission"></app-marketron-preroll-creative>
					</ng-template>
					<div class="clear"></div>
				</div>
				<ng-template #socialCreativeBlock>
					<app-marketron-display-creative
						class="social-carousel"
						[creative]="creative"
						[creativeIndex]="i"
						(previewCreativeEvent)="previewCreative($event)"
					></app-marketron-display-creative>
				</ng-template>
				<div class="clear"></div>
			</app-accordion>
			<div class="clear"></div>
		</app-accordion-group>
		<div class="no-data-container" *ngIf="!hasData">
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
				style="position: relative"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
<!--End of Table box -->
<app-modal id="creative-preview-v2">
	<app-creative-ad-preview
		[creative]="selectedCreative"
		(modalClose)="closeModal('creative-preview-v2')"
	></app-creative-ad-preview>
	<div class="modal-background"></div>
</app-modal>
